// error messages
export const NO_DATA_AT_LOCATION = 'No data is available at this location.';
export const SELECTION_OUTSIDE_STUDY_AREA = 'Selected location is outside the study area. Please choose a different location.';
export const API_ERROR_WATERSHED_DATA = 'There was a problem loading the data for this location.';
export const API_ERROR_LICENCE_DATA = 'There was a problem loading the data for this location.';
export const API_ERROR_WATERSHED_PDF = 'There was a problem generating a PDF for this report.';
export const API_ERROR_SEARCH = 'There was a problem with your search. Please try again.';
// critical errors that require reloading the page
export const API_CRITICAL_ERROR = `There was a problem loading this page.<br>
Please try again in a moment.`;
export const PDF_SUCCESSFUL_DOWNLOAD = 'Your PDF report is ready to download.';
